import { LOADING_DEFAULT_COLOR, LOADING_INACTIVE_COLOR } from 'HubStyleTokens/theme';
import styled, { keyframes } from 'styled-components';
import { isIE11 } from './operators/isIE11';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const typingColorAnimation = keyframes(["25%{background-color:", ";}75%{background-color:", ";}"], LOADING_INACTIVE_COLOR, LOADING_INACTIVE_COLOR);
let typingAnimation = keyframes(["0%,100%{transform:translateY(0);}25%{transform:translateY(.25em);}50%{transform:translateY(0);}75%{transform:translateY(-.25em);}"]);
if (isIE11()) {
  // Fix for #5734
  typingAnimation = keyframes(["0%,100%{top:0;}25%{top:.25em;}50%{top:0}75%{top:-.25em;}"]);
}
const Dot = styled.div.withConfig({
  displayName: "TypingDots__Dot",
  componentId: "sc-1r7jwz9-0"
})(["position:relative;background-color:currentColor;color:", ";border-radius:50%;height:1em;width:1em;animation:", ",", ";animation-duration:1s;animation-timing-function:linear;animation-iteration-count:infinite;&:not(:last-child){margin-right:0.75em;}&:nth-child(2){animation-delay:-0.66s;}&:nth-child(3){animation-delay:-0.33s;}"], LOADING_DEFAULT_COLOR, typingAnimation, typingColorAnimation);
const TypingDotsWrapper = styled.div.withConfig({
  displayName: "TypingDots__TypingDotsWrapper",
  componentId: "sc-1r7jwz9-1"
})(["display:flex;align-items:center;justify-content:center;height:24px;font-size:8px;width:4.5em;"]);
const TypingDots = () => {
  return /*#__PURE__*/_jsxs(TypingDotsWrapper, {
    role: "status",
    children: [/*#__PURE__*/_jsx(Dot, {
      className: "dot-1"
    }), /*#__PURE__*/_jsx(Dot, {
      className: "dot-2"
    }), /*#__PURE__*/_jsx(Dot, {
      className: "dot-3"
    })]
  });
};
TypingDots.displayName = 'TypingDots';
export default TypingDots;